import { DeletePageMeta, DeletePagePayload } from 'types/store/DeletePageState';
import { createAsyncReducer } from 'utils/Redux';

import { deletePageActions } from '../actions';

export default createAsyncReducer<DeletePageMeta, DeletePagePayload>(
  deletePageActions
);
